import { Link } from "react-router-dom";
import SVG from "../SVG";
import { Tooltip } from "react-tooltip";
export default function TableButton({
  text = "",
  svg_name = "",
  svgClassName = "",
  href = "",
  className = "",
  textShadow = "",
  svgShadow = "",
  tooltip = false,
  tooltipText = "",
  onClick,
}) {
  return (
    <div className="w-full flex items-center justify-center">
      <Link
        to={href || "#"}
        onClick={(e) => {
          if (onClick) {
            e.preventDefault();
            onClick(e);
          }
        }}
        data-tooltip-id={tooltip ? `${svg_name}Tooltip` : undefined}
        data-tooltip-content={tooltip ? tooltipText : undefined}
        className={`rounded-xl flex items-center justify-center gap-2.5 py-3 outline-none text-sm ${className}`}
      >
        <SVG
          name={svg_name}
          classname={`${svgClassName} ${svgShadow ? "drop-shadow-md" : ""}`}
        />
        {textShadow && <span className="drop-shadow-md">{text}</span>}
        {!textShadow && <span>{text}</span>}
      </Link>
      {tooltip && (
        <Tooltip
          id={`${svg_name}Tooltip`}
          place="bottom"
          className="z-50 !py-1 !px-2 !text-xs !font-thin !backdrop-blur !bg-zi-blue-dark !rounded-lg"
        />
      )}
    </div>
  );
}
